export class ActivateAccountViewModel{
    password: string;
    passwordConfirmation: string;
    token: string;
}
